import { createContext } from "react";

import { SessionContextProviderProps } from "./SessionContext.types";

export const SessionContext = createContext<SessionContextProviderProps>({});
